import '../FormConfirmation/FormConfirmation.css'
import FormConfirmationDiscount from '../FormConfirmationDiscount/FormConfirmationDiscount.jsx'
import Footer from '../Footer/footer';

const Index = () => {
  return (
    <>
      <FormConfirmationDiscount />
      <Footer />
    </>
  )
}

export default Index